import { render } from "./DialogProblemDisposal.vue?vue&type=template&id=47b12706&scoped=true"
import script from "./DialogProblemDisposal.vue?vue&type=script&lang=js"
export * from "./DialogProblemDisposal.vue?vue&type=script&lang=js"

import "./DialogProblemDisposal.vue?vue&type=style&index=0&id=47b12706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b12706"]])

export default __exports__